import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { StringHelper } from "../../../../../../../../../react-core/Helpers/StringHelper";
import { CurrencyCode } from "../../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { ChargesTransactionSummary } from "../../../../../../../../../Wrap/Models/Domains/Transactions/Summary/ChargesTransactionSummary";
import { Table } from "../../../../../../../../Shared/Table/Table";
import AriaTooltip from "../../../../../../../../Shared/Tooltip/AriaTooltip";

import { chargesToolTipText } from "../Resources/Content";

interface IChargeTableProps {
    data: Array<ChargesTransactionSummary>;
}

export const ChargesTable = (props: IChargeTableProps) => {
    const stringHelper = new StringHelper();
    return (
        <div>
            <Table
                data={props.data}
                rowCssWrapper={"product-heading"}
                col={[
                    {
                        title: "Product",
                        key: "ClAccountId",
                        render: (data, row, index) => {
                            return (
                                <>
                                    <span
                                        aria-hidden="true"
                                        className={"product-legend " + stringHelper.getDonutClass(row.ProductType, row.WrapperSubType)}
                                    ></span>
                                    <span className={stringHelper.getDonutClass(row.ProductType, row.WrapperSubType) + "-text"}>
                                        {row.ProductDisplayName}
                                    </span>
                                    <span className="account">{data}</span>
                                </>
                            );
                        },
                    },
                    {
                        title: (
                            <span>
                                Investment charge
                                <AriaTooltip
                                    cssWrapper="is-info-icon ml-5"
                                    showCloseButton={true}
                                    title="More on investment charge"
                                >
                                    {chargesToolTipText.investmentChargeToolTipText}
                                </AriaTooltip>
                            </span>
                        ),
                        key: "InvestmentAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Adviser charge",
                        key: "AdviserAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: (
                            <span>
                                Platform charge
                                <AriaTooltip
                                    cssWrapper="is-info-icon ml-5"
                                    showCloseButton={true}
                                    title="More on platform charge"
                                >
                                    {chargesToolTipText.platformchargeToolTipText}
                                </AriaTooltip>
                            </span>
                        ),
                        key: "PlatformAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Portfolio Manager Fees",
                        key: "DimAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Total",
                        key: "PlatformAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                {
                                    Amount:
                                        row.InvestmentAmount + row.AdviserAmount + row.PlatformAmount + row.DimAmount,
                                    Currency: CurrencyCode.GBP,
                                },
                                "-",
                                true
                            );
                        },
                    },
                ]}
                TotalBody={[
                    { data: "Portfolio total" },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.InvestmentAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.AdviserAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.PlatformAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.DimAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return (
                                        total +
                                        ele.DimAmount +
                                        ele.PlatformAmount +
                                        ele.AdviserAmount +
                                        ele.InvestmentAmount
                                    );
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                ]}
            ></Table>
        </div>
    );
};
